import React, { useState } from "react";
// react admin
import {
  useRedirect,
  List,
  Datagrid,
  TextField,
  TopToolbar,
  WrapperField,
  SearchInput,
  DateField,
  ReferenceField,
  useUpdate,
  useRecordContext,
  useRefresh,
  useListContext,
  useListController,
} from "react-admin";
// mui
import {
  Button,
  Menu,
  MenuItem,
  Box,
  Switch,
  useTheme,
  useMediaQuery,
} from "@mui/material";
// mui icon
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
// component
import DeleteDialog from "./dialogs/DeleteGameRTP";
import CustomPagination from "../../Components/CustomPagination";
// loader
import { Loader } from "../Loader";

// Custom Toggle Switch Component
const BooleanToggle = ({ source }) => {
  const refresh = useRefresh();
  const record = useRecordContext();
  const [update, { isLoading }] = useUpdate();

  if (!record) return null;

  const handleToggle = () => {
    update(
      "gameRtpSwitch",
      {
        id: record.id,
        data: { ...record, [source]: !record[source] },
      },
      {
        onSuccess: () => refresh(),
      }
    );
  };

  return (
    <React.Fragment>
      <Switch
        checked={record[source]}
        onChange={handleToggle}
        disabled={isLoading}
      />
      {isLoading && <Loader />}
    </React.Fragment>
  );
};

const CustomButton = () => {
  const navigate = useNavigate();
  const record = useRecordContext();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigate("/editgamertp", { state: { record } });
  };

  // Open the confirmation dialog when "Delete" is clicked
  const handleDeleteClick = () => {
    setOpenDialog(true);
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Button
        variant="contained"
        id="basic-button"
        size="small"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        sx={{ textTransform: "none" }}
        onClick={handleClick}
      >
        Actions
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        <MenuItem onClick={handleDeleteClick}>Delete</MenuItem>
      </Menu>
      {/* Pass the necessary props to DeleteDialog */}
      <DeleteDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        record={record}
      />
    </React.Fragment>
  );
};

export const GameRTP = () => {
  const { isLoading, total, page, perPage, setPage, setPerPage } =
    useListController();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const redirect = useRedirect();

  const handleClick = () => {
    redirect("/creategamertp");
  };

  const listActions = (
    <TopToolbar>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleClick}
        sx={{
          background: "#FFC107",
          color: "#0A0A0A",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#FFA000",
          },
        }}
      >
        Add RTP
      </Button>
    </TopToolbar>
  );

  const gameFilters = [
    <SearchInput
      source="gameName"
      placeholder="Enter value"
      alwaysOn
      resettable
      variant="outlined"
    />,
  ];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <Box
        sx={{
          mt: 4,
          backgroundColor: "#242424",
          borderRadius: 2,
          boxShadow: "none !important",
          padding: isSmallScreen ? { xs: 0, sm: 0 } : { xs: 1.5, sm: 2 },
        }}
      >
        <List
          title="Game RTP"
          filters={gameFilters}
          actions={listActions}
          pagination={false}
          sort={{ field: "createdAt", order: "DESC" }}
          sx={{
            "& .RaList-actions": {
              flexWrap: "nowrap",
            },
            "& .RaFilterFormInput-spacer": { display: "none" },
          }}
        >
          <Box
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            <Box
              style={{
                width: "100%",
                position: isSmallScreen ? "absolute" : "relative",
              }}
            >
              <Datagrid
                bulkActionButtons={false}
                sx={{
                  overflowX: "auto",
                  overflowY: "hidden",
                  width: "100%",
                  maxHeight: "100%",
                  "& .RaDatagrid-table": {
                    width: "100%",
                  },
                }}
              >
                <WrapperField label="Actions">
                  <CustomButton />
                </WrapperField>
                <BooleanToggle source="isActive" label="Active" />
                <ReferenceField
                  source="gameId.id"
                  reference="GameRtp"
                  label="Game Name"
                  emptyText="Missing Game"
                  link={false}
                  sortBy="gameId.name"
                >
                  <TextField source="name" />
                </ReferenceField>
                {/* <TextField source="gameName" label="Game Name" /> */}
                <TextField source="gameRtp" label="RTP" />
                <DateField source="createdAt" label="Recording Time" showTime />
              </Datagrid>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100% !important",
                  margin: "16px 0px",
                }}
              >
                <CustomPagination
                  page={page}
                  perPage={perPage}
                  total={total}
                  setPage={setPage}
                  setPerPage={setPerPage}
                />
              </Box>
            </Box>
          </Box>
        </List>
      </Box>
    </React.Fragment>
  );
};
